export enum CookLeaveRequestedBy {
    COOK = 'COOK',
    CUSTOMER = 'CUSTOMER'
}